import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Styles from './index.module.css';
// import classNames from 'classnames';
function NavBarButton({
  text,
  onClick,
  routeKey,
}) {
  const location = useLocation();
  const buttonClass = `/${routeKey}` === location.pathname ? Styles.orangeButton : Styles.BlueButton;
  return (
    <button
      type="button"
      className={buttonClass}
      onClick={() => onClick(routeKey)}
    >
      {text}
    </button>
  );
}

NavBarButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  routeKey: PropTypes.string,
};

NavBarButton.defaultProps = {
  text: '',
  onClick: () => {},
  routeKey: '',
};

export default memo(NavBarButton);
